import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { UnsubscribeEntriesParams, UnsubscribeEntriesResponse } from './types';

export async function unsubscribeEntries(params: UnsubscribeEntriesParams) {
  const url = '/web/studio/unsubs';

  const body = {
    entries: params.entries,
  };

  const response = await api.executePostRequest<ObjectResponse<UnsubscribeEntriesResponse>>(url, body);

  return response.data;
}
